import type { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import Button, { ButtonSize, ButtonVariant } from '@/components/button';
import Typography from '@/components/typography';

type Props = {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  className?: string;
  variant?: ButtonVariant;
};

export const CardFooterButton: FC<Props> = ({
  onClick,
  text,
  disabled = false,
  className = '',
  variant = ButtonVariant.GHOST,
}) => {
  return (
    <Button
      className={twMerge('m-auto px-3 py-2 hover:bg-gray-10', className)}
      disabled={disabled}
      size={ButtonSize.SMALL}
      variant={variant}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      <Typography variant="button2">{text}</Typography>
    </Button>
  );
};
